<template>
    <v-app :style="cssProps" :class="$flavorName">
        <Loading fixed v-model="loading">
            <v-layout>
                <router-view class="router-view"></router-view>
                <AlertList :key="keyAlertas" :alerts="notifications" @remove="removeAlert" @pause="pauseAlert"></AlertList>
                <Dialog :value="alert.visible" @input="alertHide" :options="alert.options" />
                <Disponibility v-if="disponibility === false" />
                <CookieConsent :loading="loading" />
                <Deploying v-if="emDeploy === true" />
            </v-layout>
        </Loading>
    </v-app>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { reduce } from 'lodash'
  import { loadFlavor } from './plugins/flavors'
  import AlertList from './components/sistema/AlertList.vue'
  import CookieConsent from './components/CookieConsent.vue'
  import Deploying from './components/Deploying.vue'

  export default {
    components: {
      CookieConsent,
      AlertList,
      Deploying
    },
    data () {
      return {
        keyAlertas: 1
      }
    },
    computed: {
      ...mapState(['loading', 'alert', 'disponibility', 'flavor', 'notifications', 'emDeploy']),
      cssProps () {
        const theme = this.$vuetify.theme.currentTheme

        this.injectTextColorClasses(theme)

        return reduce(theme, (acc, v, k) => {
          acc[`--${k}`] = v
          return acc
        }, {})
      }
    },
    watch: {
      loading (val) {
        if (!val) {
          this.$store.commit('resetCarregarLoading')
        }
      }
    },
    async created () {
      if (typeof this.flavor === 'undefined' || this.flavor === '' || this.flavor === null) {
        const currentUrl = window.location.hostname
        const href = window.location.href
        if (href.includes('painel')) {
          loadFlavor('rodobens')
        } else {
          let response = await this.$http.get(`/flavor/${currentUrl}`)
          if (typeof response.data.nm_flavor !== 'undefined' && response.data.nm_flavor !== '') {
            if (typeof this.flavor === 'undefined' || this.flavor === '' || this.flavor === null) {
              loadFlavor(response.data.nm_flavor)
            }
          }
        }
      } else {
        loadFlavor(this.flavor)
      }
    },
    methods: {
      ...mapMutations(['alertHide']),
      removeAlert (indexAlertaASerRemovido) {
        this.notifications.splice(indexAlertaASerRemovido, 1)
        this.keyAlertas++
      },
      pauseAlert (indexAlerta) {
        const alerta = this.notifications[indexAlerta]
        alerta.pause = true
        this.notifications.splice(indexAlerta, 1, alerta)
      },
      injectTextColorClasses (theme) {
        let styles = ''
        for (const [key, value] of Object.entries(theme)) {
          styles += `.theme--light.v-application .text--${key} { color: ${value} !important; }\n`
        }
        let tag = document.getElementById('injected-theme')
        if (tag) {
          tag.remove()
        }
        tag = document.createElement('style')
        tag.id = 'injected-theme'
        tag.setAttribute('type', 'text/css')
        tag.appendChild(document.createTextNode(styles))
        document.head.appendChild(tag)
      }
    }
  }

</script>
